"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
var useStatusClass_1 = __importDefault(require("./useStatusClass"));
var types_1 = require("../../types");
var useStyles = styles_1.makeStyles({
    root: {
        color: 'black',
        height: '100%',
        width: '100%',
        border: 0,
    },
});
var DocumentPageSelectInput = function (_a) {
    var _b;
    var onChange = _a.onChange, onFocus = _a.onFocus, input = _a.input;
    var classes = useStyles();
    var statusClass = useStatusClass_1.default(input.status);
    return (react_1.default.createElement("select", { className: statusClass + " " + classes.root, "data-tid": "DocumentPageSelectInput-select-" + input.id, disabled: input.status === types_1.PageInputStatus.Disabled, onChange: function (e) { return onChange(e.target.value); }, onFocus: function () { return onFocus(); }, value: (_b = input.value) !== null && _b !== void 0 ? _b : '' },
        react_1.default.createElement("option", { value: "" }, "---"),
        input.options.map(function (_a) {
            var value = _a.value, description = _a.description;
            return (react_1.default.createElement("option", { key: value, value: value }, description));
        })));
};
exports.default = DocumentPageSelectInput;
//# sourceMappingURL=DocumentPageSelectInput.js.map